import { SvgProps } from "../../types";

const Navigate = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}>
    <path
      fill="#B0B2B7"
      d="M2.062 15c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177V1.667c0-.459.163-.851.49-1.177C1.21.163 1.604 0 2.062 0h5.833v1.667H2.062v11.666h11.667V7.5h1.666v5.833c0 .459-.163.851-.49 1.177-.326.327-.718.49-1.176.49H2.062Zm3.917-4.417L4.812 9.417l7.75-7.75h-3V0h5.833v5.833H13.73v-3l-7.75 7.75Z"
    />
  </svg>
);
export default Navigate;
